<template>
    <div
        v-show="visible"
        id="user-profile"
        class="user-profile user-profile-cdn"
        :class="customPosition ? '' : 'default'"
        @click.stop="closeDialog('outside')"
    >
        <template
            v-if="isDigital"
        >
            <div
                id="userProfileWaterBox"
                ref="waterMarkBox"
                :style="{ height: userProfileSize }"
                class="user-profile-main"
                :class="customPosition ? '' : 'default'"
                @click.stop="showAvatarBox = false"
            >
                <div v-if="defaultState === 'normal'" class="user-profile-box">
                    <div
                        class="user-profile-show-box"
                        :style="[
                            {
                                background:
                                    'url(' +
                                    agentAvatarBg +
                                    ') no-repeat center -10px / cover'
                            },
                            { height: userProfileSize }
                        ]"
                    >
                        <div
                            class="close-icon-box"
                            :class="{
                                'close-opacity': defaultState !== 'normal'
                            }"
                        >
                            <img
                                src="@/assets/images/contacts/close-white.png"
                                alt=""
                                class="close-icon"
                                @click="closeDialog('close')"
                            >
                        </div>
                        <div class="user-profile-content">
                            <div ref="userMessage" class="user-message">
                                <div class="basic-message">
                                    <div class="message-left">
                                        <div class="user-name user-details">
                                            <div class="name aiAgentName">
                                                {{ userData.name
                                                }}
                                            </div>
                                            <img
                                                v-cloak
                                                src="@/assets/images/contacts/digitalEmployee.png"
                                                alt=""
                                                class="aiAgent-star"
                                            >
                                        </div>
                                        <div class="lxaccount user-details">
                                            <span>{{ userData.lxAccount }}</span>
                                        </div>
                                    </div>
                                    <div
                                        v-cloak
                                        class="message-right"
                                    >
                                        <Avatar
                                            class="user-profile-avatar"
                                            :user="userData"
                                        />
                                    </div>
                                </div>
                                <div
                                    v-if="userData.description || (userData.digitalStaff && userData.digitalStaff.description)"
                                    v-cloak
                                    class="signature"
                                >
                                    <div class="signature-text">
                                        <span>{{ userData.description || userData.digitalStaff.description }}</span>
                                    </div>
                                </div>
                            </div>
                            <div v-cloak class="department-position">
                                <div class="department-message">
                                    <div
                                        class="department-list"
                                    >
                                        <div v-if="userData.digitalStaff && userData.digitalStaff.channelName" class="department-list-one last-item">
                                            <div class="left AiWidth">
                                                <label>航道</label>
                                            </div>
                                            <div class="right">
                                                <span class="position">{{ userData.digitalStaff.channelName }}</span>
                                            </div>
                                        </div>
                                        <div v-if="userData.digitalStaff && userData.digitalStaff.positionName" class="department-list-one last-item" style="margin-top:12px;">
                                            <div class="left AiWidth">
                                                <label>职能</label>
                                            </div>
                                            <div class="right">
                                                <span class="position">{{ userData.digitalStaff.positionName }}</span>
                                            </div>
                                        </div>
                                        <div v-if="userData.digitalStaff && userData.digitalStaff.serviceTools && userData.digitalStaff.serviceTools.length" class="department-list-one last-item" style="margin-top:12px;">
                                            <div class="left AiWidth">
                                                <label>能力项</label>
                                            </div>
                                            <div class="right">
                                                <span class="position">{{ serviceToolsFn(userData.digitalStaff.serviceTools) }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div
                        class="close-icon-box"
                        :class="{
                            'close-opacity': defaultState !== 'normal'
                        }"
                    >
                        <img
                            src="@/assets/images/contacts/close-grey.png"
                            alt=""
                            class="close-icon"
                            @click="closeDialog('close')"
                        >
                    </div>
                    <div v-if="defaultState === 'loading'" class="loading">
                        <img
                            src="https://s1.longfor.com/image/40348b3e1ff6aa6833902accafcc0c4f.gif"
                            alt=""
                            class="loading-img"
                        >
                        <p class="loading-text">
                            加载中
                        </p>
                    </div>
                    <div
                        v-if="defaultState === 'dataLoadingFailed'"
                        class="data-loading-failed"
                    >
                        <img
                            src="../../assets/images/contacts/data_loading_failed.png"
                            alt=""
                            class="data-loading-failed-img"
                        >
                        <p class="data-loading-failed-text">
                            数据加载失败，请重试
                        </p>
                        <div class="data-loading-failed-btn">
                            <button
                                type="button"
                                class="reload"
                                @click="open(optionsData)"
                            >
                                重新加载
                            </button>
                        </div>
                    </div>
                    <div
                        v-if="defaultState === 'serviceAbnormal'"
                        class="data-loading-failed"
                    >
                        <img
                            src="../../assets/images/contacts/service_abnormal.png"
                            alt=""
                            class="data-loading-failed-img"
                        >
                        <p class="data-loading-failed-text">
                            服务异常，请联系IT报事
                        </p>
                        <div class="data-loading-failed-btn">
                            <button
                                type="button"
                                class="reload"
                                @click="open(optionsData)"
                            >
                                重新加载
                            </button>
                        </div>
                    </div>
                    <div
                        v-if="defaultState === 'networkAbnormal'"
                        class="data-loading-failed"
                    >
                        <img
                            src="../../assets/images/contacts/network_abnormal.png"
                            alt=""
                            class="data-loading-failed-img"
                        >
                        <p class="data-loading-failed-text">
                            当前网络不可用，请检查网络设置
                        </p>
                        <div class="data-loading-failed-btn">
                            <button
                                type="button"
                                class="reload"
                                @click="open(optionsData)"
                            >
                                重新加载
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div
            id="userProfileWaterBox"
            ref="waterMarkBox"
            :style="{ height: userProfileSize }"
            class="user-profile-main"
            :class="customPosition ? '' : 'default'"
            @click.stop="showAvatarBox = false"
        >
            <div v-if="defaultState === 'normal'" class="user-profile-box">
                <div
                    class="user-profile-show-box"
                    :style="[
                        {
                            background:
                                'url(' +
                                avatarBg +
                                ') no-repeat center center / cover'
                        },
                        { height: userProfileSize }
                    ]"
                >
                    <div
                        class="close-icon-box"
                        :class="{
                            'close-opacity': defaultState !== 'normal'
                        }"
                    >
                        <img
                            src="@/assets/images/contacts/close-white.png"
                            alt=""
                            class="close-icon"
                            @click="closeDialog('close')"
                        >
                    </div>
                    <div class="user-profile-content">
                        <div ref="userMessage" class="user-message">
                            <div class="basic-message">
                                <div class="message-left">
                                    <div class="user-name user-details">
                                        <div class="name">
                                            {{ userData.name
                                            }}<template v-if="userData.ex3">
                                                <span class="dot">·</span>{{ userData.ex3 }}
                                            </template>
                                        </div>
                                        <img
                                            v-if="
                                                userData.sex === 1 &&
                                                    userData.userType === 1
                                            "
                                            v-cloak
                                            src="@/assets/images/contacts/user_male.png"
                                            alt=""
                                            class="user-star"
                                        >
                                        <img
                                            v-if="
                                                userData.sex === 0 &&
                                                    userData.userType === 1
                                            "
                                            v-cloak
                                            src="@/assets/images/contacts/user_female.png"
                                            alt=""
                                            class="user-star"
                                        >
                                    </div>
                                    <div class="lxaccount user-details">
                                        <!--<label>账号</label>-->
                                        <span>{{ userData.lxAccount }}</span>
                                        <div
                                            v-if="userData.commonwealGradeUrl"
                                             class="user-commonweal-cdn"
                                              @mouseleave="commonwealHover = false"
                                              @mouseover="commonwealHover = true"
                                        >
                                        <div  class="user-commonweal-cdn-avatar" >
                                            <img
                                                :src=" userData.commonwealGradeUrl "
                                                alt="公益头像"
                                            >
                                        </div>
                                        <div class="user-commonweal-cdn-popover-box" v-if="commonwealHover">
                                            <div class="user-commonweal-cdn-popover"  >
                                            <div
                                                v-for="(item,
                                                        index) in userData.commonwealHover"
                                                :key="index"
                                                    class="user-commonweal-cdn-item-box"
                                                >
                                                <div
                                                    v-if="
                                                        item.gradeUrlList.length
                                                    "
                                                    class="user-commonweal-cdn-item"
                                                >
                                                    <span>{{ item.name }}</span>
                                                    <img
                                                        v-for="(img,
                                                                imgIndex) in item.gradeUrlList"
                                                        :key="imgIndex"
                                                        :src="img"
                                                        alt="公益头像"
                                                    >
                                                </div>
                                        </div>
                                        </div>
                                        </div>


                                        </div>
                                    </div>
                                    <div
                                        v-if="
                                            userData.phoneCover &&
                                                userData.isExec !== 1 &&
                                                !isDeleted
                                        "
                                        v-cloak
                                        class="phone user-details"
                                    >
                                        <!--<label>手机</label>-->
                                        <div class="phone user-phone">
                                            <span
                                                v-if="!closeEye"
                                            >{{
                                                 userData.phone.substr(0, 3)
                                             }}
                                                {{
                                                    userData.phone.substr(3, 4)
                                                }}
                                                {{
                                                    userData.phone.substr(7, 4)
                                                }}</span>
                                            <span v-if="closeEye">
                                                {{
                                                    userData.phoneCover.substr(
                                                        0,
                                                        3
                                                    )
                                                }}
                                                {{
                                                    userData.phoneCover.substr(
                                                        3,
                                                        4
                                                    )
                                                }}
                                                {{
                                                    userData.phoneCover.substr(
                                                        7,
                                                        4
                                                    )
                                                }}</span>

                                        </div>
                                        <img
                                            v-if="closeEye"
                                            src="@/assets/images/contacts/user_hide_phone.png"
                                            alt=""
                                            class="eye"
                                            @click="eyeIsOpen"
                                        >
                                        <img
                                            v-if="!closeEye"
                                            src="@/assets/images/contacts/user_show_phone.png"
                                            alt=""
                                            class="eye"
                                            @click="eyeIsOpen"
                                        >
                                    </div>
                                </div>
                                <div
                                    v-cloak
                                    class="message-right"
                                    @click.stop="showAvatar($event)"
                                >
                                    <Avatar
                                        class="user-profile-avatar"
                                        :user="userData"
                                    />
                                </div>
                            </div>
                            <div
                                v-if="userData.sign || isLoginUser"
                                v-cloak
                                class="signature"
                            >
                                <div v-if="isLoginUser" class="signature-text">
                                    <span
                                        v-if="!isEdit"
                                        class="signature-text-show"
                                    >{{ userData.sign }}</span>
                                    <span
                                        v-if="!userData.sign && !isEdit"
                                        style="color: #fff; font-size: 14px;"
                                    >添加个性签名</span>
                                    <textarea
                                        v-if="isEdit"
                                        ref="signatureInput"
                                        v-model="signature"
                                        :disabled="!isEdit"
                                        :class="{
                                            'signature-area-full':
                                                signature.length > 50
                                        }"
                                        class="signature-area"
                                        placeHolder="请输入个性签名"
                                        maxlength="50"
                                        @keydown="checkEnter($event)"
                                        @blur="saveSignature"
                                    />
                                    <img
                                        v-if="!isEdit"
                                        src="@/assets/images/contacts/user_edit_signature.png"
                                        alt=""
                                        class="edit-signature"
                                        @click="editSignature(userData.sign)"
                                    >
                                    <div
                                        v-if="isEdit"
                                        class="word-number"
                                        :class="{
                                            'signature-area-full':
                                                signature.length === 50
                                        }"
                                    >
                                        {{ signature.length }}/50
                                    </div>
                                </div>
                                <div v-if="!isLoginUser" class="signature-text">
                                    <span
                                        v-if="userData.sign"
                                        class="signature-text-show"
                                    >{{ userData.sign }}</span>
                                </div>
                            </div>
                            <div
                                v-if="
                                    isStar !== 'unknown' &&
                                        !(
                                            optionsData.hideModule &&
                                            optionsData.hideModule.indexOf(
                                                'contactsButton'
                                            ) >= 0
                                        )
                                "
                                v-cloak
                                class="btn"
                            >
                                <div
                                    v-if="!isLoginUser"
                                    class="btn-box"
                                    @click="setStar"
                                    @mouseenter="showToolTip($event, isStar)"
                                    @mouseleave="hideToolTip()"
                                >
                                    <img
                                        v-if="!isStar"
                                        class="btn-icon"
                                        :title="optionsData.targets ? '设为常用' : ''"
                                        src="@/assets/images/contacts/user_star.png"
                                        alt=""
                                    >
                                    <img
                                        v-else
                                        class="btn-icon"
                                        :title="optionsData.targets ? '移除常用' : ''"
                                        src="@/assets/images/contacts/user_unstar.png"
                                        alt=""
                                    >
                                </div>
                                <div
                                    class="btn-box"
                                    @click="shareUserProfile"
                                    @mouseenter="
                                        showToolTip($event, '分享名片')
                                    "
                                    @mouseleave="hideToolTip()"
                                >
                                    <img
                                        class="btn-icon"
                                        :title="optionsData.targets ? '分享名片' : ''"
                                        src="@/assets/images/contacts/user_share.png"
                                        alt=""
                                    >
                                </div>
                                <div
                                    v-if="!isDeleted"
                                    class="btn-box"
                                    @click="copyEmail(userData.email)"
                                    @mouseenter="
                                        showToolTip($event, '复制邮箱')
                                    "
                                    @mouseleave="hideToolTip()"
                                >
                                    <img
                                        class="btn-icon"
                                        :title="optionsData.targets ? '复制邮箱' : ''"
                                        src="@/assets/images/contacts/user_email.png"
                                        alt=""
                                    >
                                </div>
                                <div
                                    v-if="isLoginUser && !isStaff && !isDeleted"
                                    class="btn-box"
                                    @click="setting()"
                                    @mouseenter="
                                        showToolTip($event, '个人设置')
                                    "
                                    @mouseleave="hideToolTip()"
                                >
                                    <img
                                        class="btn-icon"
                                        :title="optionsData.targets ? '个人设置' : ''"
                                        src="@/assets/images/contacts/user_setting.png"
                                        alt=""
                                    >
                                </div>
                            </div>
                        </div>
                        <div
                            v-if="
                                userData.companies &&
                                    userData.companies.length > 0
                            "
                            v-cloak
                            class="company"
                        >
                            <div class="company-label">
                                所属公司
                            </div>
                            <p
                                v-for="(comp, compIndex) in userData.companies"
                                :key="compIndex"
                                class="company-text"
                            >
                                {{ comp }}
                            </p>
                        </div>
                        <div
                            v-if="
                                userData &&
                                    !isDeleted &&
                                    ((userData.deptInfo &&
                                        userData.deptInfo.length !== 0) ||
                                        (userData.projectInfo &&
                                            userData.projectInfo.length !== 0))
                            "
                            v-cloak
                            class="department-position"
                        >
                            <div
                                v-if="
                                    userData.deptInfo &&
                                        userData.deptInfo.length !== 0 &&
                                        userData.projectInfo &&
                                        userData.projectInfo.length !== 0
                                "
                                class="message-btn"
                            >
                                <span
                                    :class="
                                        activeTab === '部门' ? 'active' : ''
                                    "
                                    @click="checkTab('部门')"
                                >{{
                                    userData.userType === 1
                                        ? '部门'
                                        : '对接部门'
                                }}</span>
                                <span
                                    :class="
                                        activeTab === '项目' ? 'active' : ''
                                    "
                                    @click="checkTab('项目')"
                                >{{
                                    userData.userType === 1
                                        ? '项目'
                                        : '对接项目'
                                }}</span>
                            </div>
                            <div
                                v-if="activeTab === '部门'"
                                class="department-message"
                            >
                                <div v-if="showAllDeptFlag">
                                    <div
                                        v-for="(userdept,
                                                deptInfoIndex) in deptInfoData"
                                        :key="deptInfoIndex"
                                        class="department-list"
                                    >
                                        <div class="department-list-one">
                                            <div
                                                v-if="userData.userType === 1"
                                                class="left short"
                                            >
                                                <label
                                                    v-if="userdept.isMain === 1"
                                                >主岗</label>
                                                <label v-else>兼岗</label>
                                            </div>
                                            <div v-else class="left short">
                                                <label>部门</label>
                                            </div>
                                            <div class="right">
                                                <span
                                                    v-for="(dept,
                                                            deptIndex) in userdept.depts"
                                                    :key="deptIndex"
                                                    class="dept-breadcrumb"
                                                >
                                                    <a
                                                        :key="deptIndex"
                                                        class="deptItem"
                                                    >{{ dept.name }}</a>
                                                    <em
                                                        v-if="
                                                            deptIndex !==
                                                                userdept.depts
                                                                    .length -
                                                                1
                                                        "
                                                        class="dept-separatorline"
                                                    >
                                                        /
                                                    </em>
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            v-if="userdept.job"
                                            class="department-list-one last-item"
                                        >
                                            <div
                                                v-if="
                                                    userData.userType !== 1 &&
                                                        userData.projectInfo &&
                                                        userData.projectInfo
                                                            .length !== 0
                                                "
                                                class="left short"
                                            >
                                                <label>职位</label>
                                            </div>
                                            <div v-else class="left short">
                                                <label>职位</label>
                                            </div>
                                            <div class="right">
                                                <span class="position">{{
                                                    userdept.job
                                                }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else>
                                    <div
                                        v-for="(userdept,
                                                deptInfoIndex) in deptInfoData"
                                        :key="deptInfoIndex"
                                        class="department-list"
                                    >
                                        <div class="department-list-one">
                                            <div
                                                v-if="userData.userType === 1"
                                                class="left short"
                                            >
                                                <label
                                                    v-if="userdept.isMain === 1"
                                                >主岗</label>
                                                <label v-else>兼岗</label>
                                            </div>
                                            <div v-else class="left short">
                                                <label>部门</label>
                                            </div>
                                            <div class="right">
                                                <span
                                                    v-for="(dept,
                                                            deptIndex) in userdept.depts"
                                                    :key="deptIndex"
                                                    class="dept-breadcrumb"
                                                >
                                                    <a
                                                        :key="deptIndex"
                                                        class="deptItem"
                                                    >{{ dept.name }}</a>
                                                    <em
                                                        v-if="
                                                            deptIndex !==
                                                                userdept.depts
                                                                    .length -
                                                                1
                                                        "
                                                        class="dept-separatorline"
                                                    >
                                                        /
                                                    </em>
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            v-if="userdept.job"
                                            class="department-list-one last-item"
                                        >
                                            <div
                                                v-if="
                                                    userData.userType !== 1 &&
                                                        userData.projectInfo &&
                                                        userData.projectInfo
                                                            .length !== 0
                                                "
                                                class="left short"
                                            >
                                                <label>职位</label>
                                            </div>
                                            <div v-else class="left short">
                                                <label>职位</label>
                                            </div>
                                            <div class="right">
                                                <span class="position">{{
                                                    userdept.job
                                                }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    v-if="
                                        userData.deptInfo &&
                                            userData.deptInfo.length > 1
                                    "
                                    class="department-show-all"
                                >
                                    <div
                                        class="department-show-all-box"
                                        @click="showAllDeptInfo"
                                    >
                                        <span>{{
                                            showAllDeptFlag
                                                ? '展开全部'
                                                : '收起全部'
                                        }}</span>
                                        <img
                                            src="@/assets/images/contacts/org_show_all.png"
                                            alt=""
                                            class="org-show-all"
                                            :class="{
                                                rotate: !showAllDeptFlag
                                            }"
                                        >
                                        <img
                                            src="@/assets/images/contacts/org_show_all_hover.png"
                                            alt=""
                                            class="org-show-all-hover"
                                            :class="{
                                                rotate: !showAllDeptFlag
                                            }"
                                        >
                                    </div>
                                </div>
                            </div>
                            <div
                                v-if="activeTab === '项目'"
                                class="project-message"
                            >
                                <div v-if="showAllProjectFlag">
                                    <div
                                        v-for="(project,
                                                proIndex) in projectInfoData"
                                        :key="proIndex"
                                        class="department-list"
                                    >
                                        <div class="department-list-one">
                                            <div class="left short">
                                                <label>项目</label>
                                            </div>
                                            <div class="right">
                                                <span
                                                    v-for="(dept,
                                                            deptIndex) in project.depts"
                                                    :key="deptIndex"
                                                    class="dept-breadcrumb"
                                                >
                                                    <a
                                                        :key="deptIndex"
                                                        class="deptItem"
                                                    >{{ dept.name }}</a>
                                                    <em
                                                        v-if="
                                                            deptIndex !==
                                                                project.depts
                                                                    .length -
                                                                1
                                                        "
                                                        class="dept-separatorline"
                                                    >
                                                        /
                                                    </em>
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            v-if="project.job"
                                            class="department-list-one last-item"
                                        >
                                            <div class="left short">
                                                <label>职位</label>
                                            </div>
                                            <div class="right">
                                                <span class="position">{{
                                                    project.job
                                                }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else>
                                    <div
                                        v-for="(project,
                                                proIndex) in projectInfoData"
                                        :key="proIndex"
                                        class="department-list"
                                    >
                                        <div class="department-list-one">
                                            <div class="left short">
                                                <label>项目</label>
                                            </div>
                                            <div class="right">
                                                <span
                                                    v-for="(dept,
                                                            deptIndex) in project.depts"
                                                    :key="deptIndex"
                                                    class="dept-breadcrumb"
                                                >
                                                    <a
                                                        :key="deptIndex"
                                                        class="deptItem"
                                                    >{{ dept.name }}</a>
                                                    <em
                                                        v-if="
                                                            deptIndex !==
                                                                project.depts
                                                                    .length -
                                                                1
                                                        "
                                                        class="dept-separatorline"
                                                    >
                                                        /
                                                    </em>
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            v-if="project.job"
                                            class="department-list-one last-item"
                                        >
                                            <div class="left short">
                                                <label>职位</label>
                                            </div>
                                            <div class="right">
                                                <span class="position">{{
                                                    project.job
                                                }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    v-if="
                                        userData.projectInfo &&
                                            userData.projectInfo.length > 1
                                    "
                                    class="department-show-all"
                                >
                                    <div
                                        class="department-show-all-box"
                                        @click="showAllProjectInfo"
                                    >
                                        <span>{{
                                            showAllProjectFlag
                                                ? '展开全部'
                                                : '收起全部'
                                        }}</span>
                                        <img
                                            src="@/assets/images/contacts/org_show_all.png"
                                            alt=""
                                            class="org-show-all"
                                            :class="{
                                                rotate: !showAllProjectFlag
                                            }"
                                        >
                                        <img
                                            src="@/assets/images/contacts/org_show_all_hover.png"
                                            alt=""
                                            class="org-show-all-hover"
                                            :class="{
                                                rotate: !showAllProjectFlag
                                            }"
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            v-if="
                                userData &&
                                    !isDeleted &&
                                    userData.projectInfo &&
                                    userData.projectInfo.length === 0 &&
                                    userData.deptInfo &&
                                    userData.deptInfo.length === 0
                            "
                            v-cloak
                            class="no-organization"
                        >
                            暂无部门信息
                        </div>
                        <div v-if="isDeleted" v-cloak class="user-quit">
                            <img
                                src="@/assets/images/contacts/user_resign.png"
                                alt=""
                                class="quit-img"
                            >
                            <div v-if="userData.status === 2" class="quit-text">
                                {{
                                    userData.userType === 1
                                        ? '该账号已停用'
                                        : '该员工已离场'
                                }}
                            </div>
                            <div v-else class="quit-text">
                                {{
                                    userData.userType === 1
                                        ? '该员工已离职'
                                        : '该员工已离场'
                                }}
                            </div>
                            <p
                                v-if="!isLoginUser"
                                class="quit-function"
                                @click="handleChat()"
                            >
                                进入会话
                            </p>
                        </div>
                    </div>
                    <div
                        v-if="
                            !isDeleted &&
                                !isLoginUser &&
                                !(
                                    (userLevel < 1 || !isStaff) &&
                                    userData.isExec === 1
                                ) &&
                                !(
                                    optionsData.hideModule &&
                                    optionsData.hideModule.indexOf(
                                        'imButton'
                                    ) >= 0
                                )
                        "
                        v-cloak
                        class="user-function-box"
                    >
                        <div class="user-function">
                            <div
                                v-if="userData.isExec !== 1"
                                class="function-btn audio"
                                @click="handleAudio"
                            >
                                <img
                                    src="@/assets/images/contacts/user_audio.png"
                                    alt=""
                                    class="btn-icon"
                                >
                                <img
                                    src="@/assets/images/contacts/user_audio_hover.png"
                                    alt=""
                                    class="btn-icon-hover"
                                >
                                <span>语音通话</span>
                            </div>
                            <div
                                v-if="userData.isExec !== 1"
                                class="function-btn video"
                                @click="handleVideo"
                            >
                                <img
                                    src="@/assets/images/contacts/user_video.png"
                                    alt=""
                                    class="btn-icon"
                                >
                                <img
                                    src="@/assets/images/contacts/user_video_hover.png"
                                    alt=""
                                    class="btn-icon-hover"
                                >
                                <span>视频通话</span>
                            </div>
                            <div class="function-btn chat" @click="handleChat">
                                <img
                                    src="@/assets/images/contacts/user_message.png"
                                    alt=""
                                    class="btn-icon"
                                >
                                <img
                                    src="@/assets/images/contacts/user_message_hover.png"
                                    alt=""
                                    class="btn-icon-hover"
                                >
                                <span>发消息</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="avatar-box"
                    :class="{
                        showAvatarBox: showAvatarBox
                        // isLoginUser: isLoginUser && !isIe() // cdn无上传头像按钮，所以注释掉
                    }"
                    @click.stop=""
                >
                    <div
                        v-if="avatarUrl"
                        class="avatar-main"
                        :style="{
                            background:
                                'url(' +
                                avatarUrl +
                                ') no-repeat center center / cover'
                        }"
                    />
                    <div v-else class="avatar-main" :class="avatarColorClass">
                        {{ avatarWord }}
                    </div>
                </div>
                <div
                    class="avatar-update-box"
                    :class="{
                        updateBoxIsShow: updateBoxIsShow
                    }"
                    @click.stop=""
                >
                    <div class="update-avatar-main">
                        <img
                            ref="avatarImgDate"
                            :src="avatarFile.base64"
                            alt
                            :style="[
                                {
                                    width:
                                        avatarImageStyle.width === 0
                                            ? 'auto'
                                            : avatarImageStyle.width + '%'
                                },
                                {
                                    height:
                                        avatarImageStyle.height === 0
                                            ? 'auto'
                                            : avatarImageStyle.height + '%'
                                }
                            ]"
                        >
                    </div>
                    <div class="update-avatar-operate">
                        <div class="update-avatar-operate-main">
                            <div
                                v-if="avatarEnlargeFlag === 'avatar_enlarge'"
                                class="update-avatar-operate-enlarge"
                                @click="toBigChange"
                            >
                                <img
                                    class="avatar-enlarge-hover-img"
                                    src="../../assets/images/contacts/avatar-enlarge.png"
                                    alt=""
                                >
                                <img
                                    class="avatar-enlarge-hover"
                                    src="../../assets/images/contacts/avatar-enlarge-hover.png"
                                    alt=""
                                >
                            </div>
                            <div v-else class="update-avatar-operate-enlarge">
                                <img
                                    src="../../assets/images/contacts/avatar-enlarge-grey.png"
                                    alt=""
                                >
                            </div>
                            <div class="update-avatar-operate-line" />
                            <div
                                v-if="avatarNarrowFlag === 'avatar_narrow_grey'"
                                class="update-avatar-operate-narrow"
                            >
                                <img
                                    src="../../assets/images/contacts/avatar-narrow-grey.png"
                                    alt=""
                                >
                            </div>
                            <div
                                v-else
                                class="update-avatar-operate-narrow"
                                @click="toSmallChange"
                            >
                                <img
                                    class="avatar-narrow-hover-img"
                                    src="../../assets/images/contacts/avatar-narrow.png"
                                    alt=""
                                >
                                <img
                                    class="avatar-narrow-hover"
                                    src="../../assets/images/contacts/avatar-narrow-hover.png"
                                    alt=""
                                >
                            </div>
                        </div>
                    </div>
                    <div class="update-avatar-button">
                        <button
                            class="update-avatar-button-cancel"
                            :disabled="updateAvatarFlag"
                            @click="uploadAvatarCancel"
                        >
                            取消
                        </button>
                        <button
                            class="update-avatar-button-submit"
                            :disabled="updateAvatarFlag"
                            @click="uploadAvatarSubmit"
                        >
                            保存
                        </button>
                    </div>
                </div>
                <div
                    v-show="tipShow"
                    class="tips"
                    :style="{ width: isIe() ? '196px' : 'auto' }"
                >
                    <img
                        src="@/assets/images/contacts/user_tips_success.png"
                        alt=""
                        class="tips-img"
                    >
                    <span>{{ tipText }}</span>
                </div>
            </div>
            <div v-else>
                <div
                    class="close-icon-box"
                    :class="{
                        'close-opacity': defaultState !== 'normal'
                    }"
                >
                    <img
                        src="@/assets/images/contacts/close-grey.png"
                        alt=""
                        class="close-icon"
                        @click="closeDialog('close')"
                    >
                </div>
                <div v-if="defaultState === 'loading'" class="loading">
                    <img
                        src="https://s1.longfor.com/image/40348b3e1ff6aa6833902accafcc0c4f.gif"
                        alt=""
                        class="loading-img"
                    >
                    <p class="loading-text">
                        加载中
                    </p>
                </div>
                <div
                    v-if="defaultState === 'dataLoadingFailed'"
                    class="data-loading-failed"
                >
                    <img
                        src="../../assets/images/contacts/data_loading_failed.png"
                        alt=""
                        class="data-loading-failed-img"
                    >
                    <p class="data-loading-failed-text">
                        数据加载失败，请重试
                    </p>
                    <div class="data-loading-failed-btn">
                        <button
                            type="button"
                            class="reload"
                            @click="open(optionsData, callback)"
                        >
                            重新加载
                        </button>
                    </div>
                </div>
                <div
                    v-if="defaultState === 'serviceAbnormal'"
                    class="data-loading-failed"
                >
                    <img
                        src="../../assets/images/contacts/service_abnormal.png"
                        alt=""
                        class="data-loading-failed-img"
                    >
                    <p class="data-loading-failed-text">
                        服务异常，请联系IT报事
                    </p>
                    <div class="data-loading-failed-btn">
                        <button
                            type="button"
                            class="reload"
                            @click="open(optionsData, callback)"
                        >
                            重新加载
                        </button>
                    </div>
                </div>
                <div
                    v-if="defaultState === 'networkAbnormal'"
                    class="data-loading-failed"
                >
                    <img
                        src="../../assets/images/contacts/network_abnormal.png"
                        alt=""
                        class="data-loading-failed-img"
                    >
                    <p class="data-loading-failed-text">
                        当前网络不可用，请检查网络设置
                    </p>
                    <div class="data-loading-failed-btn">
                        <button
                            type="button"
                            class="reload"
                            @click="open(optionsData, callback)"
                        >
                            重新加载
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <span
            class="star-text-set"
            :style="{
                left: starLeft + 'px',
                top: starTop + 'px',
                display: starDisplay
            }"
        >{{ starText }}</span>
        </template>
    </div>
</template>

<script>
import Avatar from '@/components/Avatar'
import defaultAvatar from '@/assets/images/contacts/longxiaohu.png'
import agentAvatarBg from '@/assets/images/contacts/digitalbg.png'
import {
    getStaffInfo,
    getRightsByToken,
    setFavorContact,
    deleteFavorContact,
    savePersonalPicture,
    savePersonalSignature,
    getJumpUrl
} from '@/apis/contactsWindow/contactsWindow'
import watermark from '@/utils/contacts/watermark.js'
import { configer } from '@/config'
import contactsConfig from '@/utils/contacts/config'
import CryptoJS from 'crypto-js'

export default {
    name: 'UserProfile',
    components: {
        Avatar
    },
    data() {
        return {
            defaultState: '', // normal -> 正常加载；loading -> 加载中；dataLoadingFailed -> 数据加载失败；serviceAbnormal -> 服务异常；networkAbnormal -> 当前网络不可用
            optionsData: {}, // 存一下传进来的options，以便重新加载用
            visible: false, // 弹框是否打开
            isStar: 'unknown', // 是否是常用联系人
            userData: {}, // 用户信息
            agentAvatarBg: agentAvatarBg, // 数字人个人信息页背景图
            deptInfoData: [], // 用户部门信息
            showAllDeptFlag: true, // 展示用户所有部门开关
            projectInfoData: [], // 用户项目信息
            showAllProjectFlag: true, // 展示用户所有项目开关
            tipShow: false, // 提示是否显示
            tipText: '', // 提示是否显示
            closeEye: true,
            activeTab: '部门',
            userType: null,
            isEdit: false,
            signature: '',
            isLoginUser: false, // 是否是当前登录人
            loginRights: {}, // 当前登录人信息和权限
            showAvatarBox: false,
            avatarUrl: '',
            avatarWord: '',
            avatarColorClass: '',
            contactRootNode: {
                longforCorporationPid: '1000000004',
                longforPid: '1000000003',
                regionPid: '6000000001'
            },
            okrUrl: '',
            spaceUrl: '',
            scheduleUrl: '',
            supplierUrl: '',
            userAvatarUrl: '', // 用户头像url
            avatarBg: 'https://s1.longfor.com/image/ab11d14bcf790ae1c2517a393acb8ad2.png', // 用户头像url
            avatarFile: {}, // 头像列表
            formData: null,
            updateBoxIsShow: false, // 上传头像弹窗开关
            avatarEnlargeFlag: 'avatar_enlarge',
            avatarNarrowFlag: 'avatar_narrow_grey',
            avatarImageStyle: {
                setStyle: 'width',
                width: 0,
                height: 0
            },
            updateAvatarFlag: false,
            customPosition: false,
            showUserProfileFlag: true, // 个人信息页展示开关，防止用户频繁点击同一个人
            busy: false,
            userClose: false,
            starText: '',
            starTop: 0,
            starLeft: 0,
            starDisplay: 'none',
            configer: {
                contactsAvatarURL: configer.contactsAvatarURL,
                desktopUrl: configer.desktopUrl
            },
            callback: '',
            userProfileSize: '540px',
            scheduleDialog: false,
            allJoinerUserCodes: [],
            busyHelperTime: {
                date: '',
                startMonent: '',
                endMonent: ''
            },
            commonwealHover: false,
            isDigital: false // 是否是数字员工
        }
    },
    computed: {
        // 是否是离职员工
        isDeleted() {
            return this.userData && this.userData.status !== 1
        },
        isStaff() {
            return this.loginRights.userType === 1
        },
        // 是否有通讯录权限:-1无权限;0低权限;1高权限
        userLevel() {
            return !this.loginRights.authorityGrade ? -2 : +this.loginRights.authorityGrade
        }
    },
    methods: {
        serviceToolsFn(serviceTools) {
            let tempStr = ``
            serviceTools.forEach((item, i) => {
                tempStr += `${(i !== 0 ? '、' : '') + item.name}`
            })
            return tempStr
        },
        open(options, callback) {
            // 下游如果传了token，带到请求头里面
            if (options.token) {
                window.contactsToken = options.token
            } else if (window.contactsToken) {
                window.contactsToken = ''
            }
            const context = this
            this.callback = callback
            // this.contactsZhugeTrack('clickContactsPersonalPageSdkInvoke')
            context.optionsData = options // 重新加载需要
            context.getJumpUrl(options, () => {
                if (options.account || options.userId) {
                    context.openUp(options)
                } else {
                    context.$message({
                        message: '未获取到用户信息',
                        type: 'error',
                        duration: 3000
                    })
                }
            })
        },
        openUp(options) {
            const context = this
            // 300毫秒后不管接口请求到与否，都展示弹框。（请求到数据正常展示，没请求到就展示loading）
            setTimeout(() => {
                if (!context.visible && !context.userClose) {
                    context.visible = true
                }
            }, contactsConfig.loadingTimeout)
            if (context.busy) {
                return
            }
            context.busy = true
            context.initData(options)
            this.getRights(options)
            // 点击左侧导航，隐藏个人信息
            if (document.getElementById('mainNav')) {
                document.getElementById('mainNav').addEventListener('click', e => {
                    const con1 = document.getElementById('user-profile')
                    if (con1) {
                        if (!con1.contains(e.target)) {
                            context.visible = false
                        }
                    }
                })
            }
        },
        getJumpUrl(options, callback) {
            const context = this
            // if (options.systemSource) {
            getJumpUrl({ terminalType: 'WEB' })
                .then(res => {
                    if (res.code === '0') {
                        const urlData = res.data
                        for (let i = 0; i < urlData.length; i++) {
                            if (urlData[i].urlType === 5) {
                                if (+urlData[i].appKey) {
                                    // appKey 的值为 0和空 代表放过，1代表校验
                                    const systemSourceData = urlData[
                                        i
                                    ].jumpUrl.split(',')
                                    if (
                                        systemSourceData.indexOf(
                                            options.systemSource
                                        ) >= 0
                                    ) {
                                        callback()
                                    } else {
                                        context.busy = false
                                        context.$message({
                                            message: '暂无权限',
                                            type: 'info',
                                            duration: 3000
                                        })
                                    }
                                } else {
                                    callback()
                                }
                            }
                        }
                        context.jumpUrlDataFormat(urlData) // 处理跳转链接
                    } else {
                        context.busy = false
                        context.visible = true
                        this.defaultState = 'dataLoadingFailed'
                    }
                })
                .catch(err => {
                    context.busy = false
                    context.visible = true
                    console.warn(err)
                    if (err.message === 'Network Error') {
                        this.defaultState = 'networkAbnormal' // 当前网络不可用，请检查网络设置
                    } else {
                        this.defaultState = 'serviceAbnormal' // 服务异常，请联系IT报事
                    }
                })
            // } else {
            //     context.busy = false
            //     this.$message({
            //         message: '暂无权限',
            //         type: 'info',
            //         duration: 3000
            //     })
            // }
        },
        // 添加水印
        addWaterMark(res) {
            const waterOption = {
                id: '1.23452384164.123454312',
                parentId: 'userProfileWaterBox',
                account: res.data.lxAccount,
                left: '0',
                top: '0',
                width: '360px',
                height: '540px',
                zIndex: 100,
                el: this.$refs.waterMarkBox
            }
            if (document.getElementById(waterOption.id) === null) {
                watermark.set(waterOption)
            }
        },
        getRights(options) {
            const context = this
            getRightsByToken()
                .then(res => {
                    if (res.code === '0' && res.data !== null) {
                        this.loginRights = res.data
                        // 获取到用户信息后添加水印
                        this.addWaterMark(res)
                    } else {
                        context.defaultState = 'dataLoadingFailed' // 数据加载失败，请重试
                        return
                    }
                    context.getUserProfile(options)
                })
                .catch(err => {
                    console.warn(err)
                    context.busy = false
                    context.visible = true
                    if (err.message === 'Network Error') {
                        context.defaultState = 'networkAbnormal' // 当前网络不可用，请检查网络设置
                    } else {
                        context.defaultState = 'serviceAbnormal' // 服务异常，请联系IT报事
                    }
                })
        },
        initData(options) {
            const context = this
            // 必须初始化这些数据，否则再次进入这些值还是上次的
            context.showAvatarBox = false // 隐藏大图
            context.updateBoxIsShow = false // 隐藏上传选择头像窗口
            context.activeTab = '部门'
            context.userData = {}
            context.isStar = 'unknown' // 初始化是否为常用联系人，否则页面会闪一下
            context.closeEye = true
            context.userAvatarUrl = ''
            context.defaultState = 'loading'
            context.userClose = false
            if (options.size) {
                // 下游自定义高度，默认default 540， 中等尺寸medium 480， 小尺寸 small 420;
                if (options.size === 'medium') {
                    context.userProfileSize = '480px'
                } else if (options.size === 'small') {
                    context.userProfileSize = '420px'
                } else {
                    context.userProfileSize = '540px'
                }
            } else {
                context.userProfileSize = '540px'
            }
            // 下游调用个人信息页位置支持配置
            context.customPosition = false // 初始化，默认为false
            if (options.targets) {
                context.customPosition = true
                options.targets.appendChild(window.userProfileEl)
            } else {
                document.body.appendChild(window.userProfileEl)
            }
            // 当浏览器窗口放不下个人信息页卡片时获取窗口尺寸，让个人信息页下移自身高度减去窗口可视高度的一半
            const windowHeight = document.body.clientHeight
            if (windowHeight < 540) {
                const translateY = Math.ceil((540 - windowHeight) / 2)
                this.$refs.waterMarkBox.style.marginTop = `${translateY}px`
            } else {
                this.$refs.waterMarkBox.style.marginTop = 'auto'
            }
        },
        getUserProfile(options) {
            const context = this
            getStaffInfo({
                account: options.account,
                uid: options.userId
            })
                .then(res => {
                    // 慢网情况下，如果加载出数据前用户手动点击×关闭了，那么等接口有返回值了，将不再展示弹框
                    if (!context.userClose) {
                        context.visible = true
                    }
                    context.busy = false
                    if (res.code === '0') {
                        this.isDigital = res?.data?.uId?.startsWith('AI_AGENT_') || res?.data?.userId?.startsWith('AI_AGENT_')
                        context.activeUserId = res.data.uId
                        context.isLoginUser =
                            context.activeUserId === context.loginRights.uid
                        context.defaultState = 'normal'
                        if (
                            res.data.deptInfo &&
                            res.data.deptInfo.length === 0 &&
                            res.data.projectInfo &&
                            res.data.projectInfo.length !== 0
                        ) {
                            context.activeTab = '项目'
                        }
                        context.userData = res.data
                        // 当用户有多部门或多项目时只展示一个
                        context.deptInfoData = res.data.deptInfo.slice(0)
                        context.projectInfoData = res.data.projectInfo.slice(0)
                        if (
                            context.deptInfoData &&
                            context.deptInfoData.length > 1
                        ) {
                            context.showAllDeptFlag = true
                            context.deptInfoData.splice(
                                1,
                                context.deptInfoData.length
                            )
                        }
                        if (
                            context.projectInfoData &&
                            context.projectInfoData.length > 1
                        ) {
                            context.showAllProjectFlag = true
                            context.projectInfoData.splice(
                                1,
                                context.projectInfoData.length
                            )
                        }
                        context.isStar = res.data.isFrequentContact === 1
                        // 保存用户头像小图
                        const userInfo = res.data
                        if (userInfo && userInfo.headId) {
                            const headId = +userInfo.headId
                            if (headId > 0 && headId <= 10) {
                                context.userAvatarUrl =
                                    this.configer.contactsAvatarURL +
                                    'default/' +
                                    userInfo.uId +
                                    '.jpg?headId=' +
                                    userInfo.headId
                            } else if (headId > 10) {
                                context.userAvatarUrl =
                                    this.configer.contactsAvatarURL +
                                    userInfo.uId +
                                    '.jpg?headId=' +
                                    userInfo.headId
                            }
                        } else {
                            context.userAvatarUrl = defaultAvatar
                        }
                         if (
                            res.data.phoneEncrypted &&
                            res.data.agreedKey &&
                            res.data.lxAccount
                        ) {
                            context.userData.phone = this.cryptDes(
                                res.data.phoneEncrypted,
                                res.data.agreedKey +
                                    CryptoJS.MD5(res.data.lxAccount)
                                        .toString()
                                        .substr(0, 3)
                            )
                        }

                        // if (userInfo.portraitUrl) {
                        //     // 用户有完整头像地址，直接展示
                        //     if (userInfo.portraitUrl.indexOf('{1}') >= 0) {
                        //         userInfo.portraitUrl = userInfo.portraitUrl.replace('{1}', '/small/')
                        //         context.userAvatarUrl = userInfo.portraitUrl
                        //     }
                        // }
                    } else {
                        context.defaultState = 'dataLoadingFailed' // 数据加载失败，请重试
                    }
                })
                .catch(err => {
                    context.busy = false
                    context.visible = true
                    if (err.message === 'Network Error') {
                        context.defaultState = 'networkAbnormal' // 当前网络不可用，请检查网络设置
                    } else {
                        context.defaultState = 'serviceAbnormal' // 服务异常，请联系IT报事
                    }
                    console.warn(err)
                })
        },
        cryptDes(string, key) {
            // 解密
            if (string === '' || string === null || string === undefined) {
                return ''
            }
            if (typeof string !== 'string') {
                string = string.toString()
            }
            const KeyHex = CryptoJS.enc.Utf8.parse(key)
            var decrypted = CryptoJS.DES.decrypt(
                {
                    ciphertext: CryptoJS.enc.Base64.parse(string)
                },
                KeyHex,
                {
                    mode: CryptoJS.mode.ECB,
                    padding: CryptoJS.pad.Pkcs7
                }
            )
            return decrypted.toString(CryptoJS.enc.Utf8)
        },
        // 处理跳转链接，res.data.urlType跳转链接类型，1:OKR的查看详情链接；2:团队空间-进入所属团队链接；3:日程忙闲的链接；4:供方设置跳供应商主数据的链接;5:个人信息页系统白名单；6:选人组件系统白名单
        jumpUrlDataFormat(jumpUrl) {
            const context = this
            if (jumpUrl.length > 0) {
                for (let i = 0; i < jumpUrl.length; i++) {
                    if (+jumpUrl[i].urlType === 1) {
                        // 兼容string和number
                        context.okrUrl = jumpUrl[i].appKey
                    } else if (+jumpUrl[i].urlType === 2) {
                        context.spaceUrl = jumpUrl[i].jumpUrl
                    } else if (+jumpUrl[i].urlType === 3) {
                        context.scheduleUrl = jumpUrl[i].jumpUrl
                    } else if (+jumpUrl[i].urlType === 4) {
                        context.supplierUrl = jumpUrl[i].appKey
                    }
                }
            }
        },
        closeDialog(type = '') {
            if (this.isEdit) {
                return
            }
            if (this.optionsData.targets && this.optionsData.targets.contains(window.userProfileEl)) {
                this.optionsData.targets.removeChild(window.userProfileEl)
            } else {
                document.body.removeChild(window.userProfileEl)
            }
            this.visible = false
            this.userClose = true
            const data = {
                status: 1001
            }
            // 提供给会议的方法
            if (this.optionsData.closeCallback) {
                this.optionsData.closeCallback(type)
            }
            // 提供给在线文档的回调
            if (this.callback) {
                return this.callback(data)
            }
        },
        setStar() {
            const context = this
            if (context.isStar) {
                deleteFavorContact(context.activeUserId).then(res => {
                    if (res.code === '0') {
                        context.tipShow = true
                        context.isStar = false
                        context.starText = '设为常用'
                        context.tipText = '已从常用联系人中移除'
                        context.userData.isFrequentContact = 0
                    } else if (res.code === '401') {
                        context.$message({
                            message: res.message,
                            type: 'error',
                            duration: 3000
                        })
                        return
                    }
                    setTimeout(() => {
                        context.tipShow = false
                    }, 1000)
                })
            } else {
                setFavorContact(context.activeUserId).then(res => {
                    if (res.code === '0') {
                        context.tipShow = true
                        context.isStar = true
                        context.starText = '移除常用'
                        context.tipText = '已添加至常用联系人'
                        context.userData.isFrequentContact = 1
                    } else if (res.code === '401') {
                        context.$message({
                            message: res.message,
                            type: 'error',
                            duration: 3000
                        })
                        return
                    }
                    setTimeout(() => {
                        context.tipShow = false
                    }, 1000)
                })
            }
        },
        shareUserProfile() {
            const context = this
            const userData = context.userData || {} // 查看人信息
            const loginRights = context.loginRights || {} // 当前登录人信息
            const forwardParams = {
                objectName: 'RC:CardMsg',
                content: {
                    userId: userData.uId, // 用户id
                    name: userData.name, // 用户姓名
                    // portraitUri: userData.portraitUrl // 头像地址
                    portraitUri: context.userAvatarUrl // 头像地址
                }
            }
            const msgBody = encodeURIComponent(JSON.stringify(forwardParams))
            window.location.href =
                this.configer.desktopUrl +
                'workbench/shareTo?account=' +
                loginRights.lxAccount +
                '&channel=IM&msgBody=' +
                msgBody
            this.hideToolTip()
        },
        copyEmail(content) {
            if (content) {
                const inputElement = document.createElement('input')
                inputElement.type = 'text'
                inputElement.value = content
                document.body.appendChild(inputElement)
                // 选择增加的input元素
                inputElement.select()
                if (document.execCommand('Copy')) {
                    // 如果复制成功
                    this.tipShow = true
                    this.tipText = '邮箱号复制成功'
                    setTimeout(() => {
                        this.tipShow = false
                    }, 1000)
                } else {
                    this.tipShow = true
                    this.tipText = '邮箱号复制失败'
                    setTimeout(() => {
                        this.tipShow = false
                    }, 1000)
                }
                // 复制成功之后删除增加的这个input元素
                document.body.removeChild(inputElement)
            } else {
                this.tipShow = true
                this.tipText = '暂无邮箱'
                setTimeout(() => {
                    this.tipShow = false
                }, 1000)
            }
        },
        setting() {
            if (this.supplierUrl) {
                window.webViewOpen(this.supplierUrl, 'userinfor')
                this.hideToolTip()
                this.closeDialog('setting')
            } else {
                this.$message({
                    type: 'info',
                    message: '敬请期待'
                })
            }
        },
        eyeIsOpen() {
            // if (this.closeEye) {
            //     this.contactsZhugeTrack('clickContactsPersonalPagePhone', { BE_VIEWED_ACCOUNT: this.userData.lxAccount })
            // }
            this.closeEye = !this.closeEye
        },
        getFormatePhone(phone) {
            phone += ''
            if (phone) {
                phone = `${phone.substr(0, 3)} **** ${phone.substring(7, 11)}`
            }
            return phone
        },
        handleAudio() {
            // 语音通话
            // this.contactsZhugeTrack('clickContactsPersonalPageVoiceCall', { BE_VIEWED_ACCOUNT: this.userData.lxAccount })
            this.jumpDeskTop()
        },
        handleVideo() {
            // 视频通话
            // this.contactsZhugeTrack('clickContactsPersonalPageVideoCall', { BE_VIEWED_ACCOUNT: this.userData.lxAccount })
            this.jumpDeskTop()
        },
        handleChat() {
            // 发消息
            // this.contactsZhugeTrack('clickContactsPersonalPageImChat', { BE_VIEWED_ACCOUNT: this.userData.lxAccount })
            this.jumpDeskTop()
        },
        jumpDeskTop() {
            const context = this
            const userData = context.userData || {} // 查看人信息
            const loginRights = context.loginRights || {} // 当前登录人信息
            if (!userData.uId) {
                context.$message({
                    message: '未获取到用户信息',
                    type: 'error',
                    duration: 3000
                })
                return
            }
            window.location.href =
                this.configer.desktopUrl +
                'im/startChat?conversationType=1&targetId=' +
                userData.uId +
                '&account=' +
                loginRights.lxAccount
        },
        // 切换部门/项目tab
        checkTab(val) {
            this.activeTab = val
        },
        // 唤起textarea编辑个签
        editSignature(val) {
            this.isEdit = true
            this.signature = val === null ? '' : val
            this.$nextTick(() => {
                this.$refs.signatureInput.focus()
            })
        },
        // 个性签名清空按钮
        resetSignature(event) {
            event.preventDefault()
            this.signature = ''
        },
        // 回车失去焦点
        checkEnter(e) {
            const keycode = e.keyCode
            if (keycode === 13) {
                e.preventDefault()
                this.$refs.signatureInput.blur()
            }
        },
        // 失去焦点
        saveSignature() {
            this.isEdit = false
            const data = {
                content: this.signature
            }
            const sign = this.userData.sign // 记录之前的签名
            this.userData.sign = data.content // 先改变视图，防止blur后闪一下
            savePersonalSignature(data)
                .then(res => {
                    if (res.code !== '0') {
                        // 如果接口请求失败了，恢复之前的签名
                        this.userData.sign = sign
                        this.$message({
                            message: res.message,
                            type: 'error',
                            duration: 3000
                        })
                    }
                })
                .catch(e => {
                    console.warn(e)
                    this.userData.sign = sign
                })
        },
        showAvatar(e) {
            if (this.showAvatarBox) {
                this.showAvatarBox = false
                return
            }
            let url = e.currentTarget.querySelector('.per-avatar').src || ''
            if (
                e.currentTarget.querySelector('.per-avatar').src &&
                e.currentTarget
                    .querySelector('.per-avatar')
                    .src.indexOf('/small/')
            ) {
                url = url.replace('/small/', '/')
            }
            this.avatarUrl = url || defaultAvatar
            this.showAvatarBox = true
        },
        // 点击上传头像
        uploadAvatar(e) {
            const context = this
            context.avatarImageStyle.setStyle = 'width'
            context.avatarImageStyle.width = 0
            context.avatarImageStyle.height = 0
            context.avatarEnlargeFlag = 'avatar_enlarge'
            context.avatarNarrowFlag = 'avatar_narrow_grey'
            const files = e.target.files
            // const formData = new FormData() // formData对象
            if (!files[0].type.match(/.jpg|.png|.jpeg/i)) {
                this.$message({
                    message: '图片格式错误,请上传png/jpg/jpeg格式的图片!',
                    type: 'error',
                    duration: 3000
                })
                return
            }
            const reader = new FileReader()
            reader.onload = data => {
                const imgMsg = {
                    name: data.target.fileName, // 获取文件名
                    base64: data.target.result // base64或ArrayBuffer类型的数据
                }
                this.avatarFile = imgMsg
                // 获取上传图片的尺寸
                const avatarImage = new Image()
                avatarImage.src = data.target.result
                avatarImage.onload = function() {
                    if (this.width <= this.height) {
                        context.avatarImageStyle.setStyle = 'width'
                        context.avatarImageStyle.width = 100
                        context.avatarImageStyle.height = 0
                    } else if (this.width > this.height) {
                        context.avatarImageStyle.setStyle = 'height'
                        context.avatarImageStyle.width = 0
                        context.avatarImageStyle.height = 100
                    }
                    // 展示选择的图片
                    context.updateBoxIsShow = true
                }
            }
            reader.readAsDataURL(files[0]) // 将file读取为base64，并存在reader.result里
            reader.fileName = files[0].name
        },
        // 放大头像
        toBigChange() {
            if (this.avatarImageStyle.setStyle === 'width') {
                if (this.avatarImageStyle.width >= 200) {
                    return
                }
                this.avatarNarrowFlag = 'avatar_narrow'
                this.avatarImageStyle.width += 20
                if (this.avatarImageStyle.width >= 200) {
                    this.avatarEnlargeFlag = 'avatar_enlarge_grey'
                }
            } else {
                if (this.avatarImageStyle.height >= 200) {
                    return
                }
                this.avatarNarrowFlag = 'avatar_narrow'
                this.avatarImageStyle.height += 20
                if (this.avatarImageStyle.height >= 200) {
                    this.avatarEnlargeFlag = 'avatar_enlarge_grey'
                }
            }
        },
        // 缩小头像
        toSmallChange() {
            if (this.avatarImageStyle.setStyle === 'width') {
                this.avatarEnlargeFlag = 'avatar_enlarge'
                if (this.avatarImageStyle.width <= 100) {
                    return
                }
                this.avatarImageStyle.width -= 20
                if (this.avatarImageStyle.width <= 100) {
                    this.avatarNarrowFlag = 'avatar_narrow_grey'
                }
            } else {
                this.avatarEnlargeFlag = 'avatar_enlarge'
                if (this.avatarImageStyle.height <= 100) {
                    return
                }
                this.avatarImageStyle.height -= 20
                if (this.avatarImageStyle.height <= 100) {
                    this.avatarNarrowFlag = 'avatar_narrow_grey'
                }
            }
        },
        // 取消上传头像
        uploadAvatarCancel() {
            this.$refs.fileInput.value = null
            this.updateBoxIsShow = false
        },
        // 提交数据
        uploadAvatarSubmit() {
            this.updateAvatarFlag = true
            const context = this
            // 获取宽高，坐标，动态生成canvas截图
            const imgWidth = this.$refs.avatarImgDate.width
            const imgHeight = this.$refs.avatarImgDate.height
            const imgData = this.$refs.avatarImgDate
            const sx = -(imgWidth / 2 - 150)
            const sy = -(imgHeight / 2 - 150)
            const canvas = document.createElement('canvas')
            canvas.width = 300
            canvas.height = 300
            const ctx = canvas.getContext('2d')
            ctx.drawImage(imgData, sx, sy, imgWidth, imgHeight)
            // 画图结束
            // 透明背景设置白色底色
            const picData = ctx.getImageData(sx, sy, imgWidth, imgHeight)
            for (let i = 0; i < picData.data.length; i += 4) {
                // 判断是否为透明底色
                if (picData.data[i + 3] === 0) {
                    picData.data[i] = 255
                    picData.data[i + 1] = 255
                    picData.data[i + 2] = 255
                    picData.data[i + 3] = 255
                }
            }
            ctx.putImageData(picData, sx, sy)
            // 设置底色完毕
            const imgDataBase = canvas.toDataURL('image/png')
            const temp = context.dataURLtoFile(
                imgDataBase,
                this.avatarFile.name
            )
            const formData = new FormData()
            formData.append('file', temp)
            savePersonalPicture(formData)
                .then(res => {
                    if (res.code === '0') {
                        this.$refs.fileInput.value = null
                        this.showAvatarBox = false
                        this.updateBoxIsShow = false
                        // context.userData.portraitUrl = res.data.portraitUrl
                        context.userData.headId = res.data.headId
                        // 更新背景图
                        context.userAvatarUrl =
                            this.configer.contactsAvatarURL +
                            context.userData.uId +
                            '.jpg?headId=' +
                            res.data.headId
                        // if (res.data.portraitUrl.indexOf('{1}') >= 0) {
                        //     res.data.portraitUrl = res.data.portraitUrl.replace(
                        //         '{1}',
                        //         '/small/'
                        //     )
                        //     context.userAvatarUrl = res.data.portraitUrl
                        // }
                    } else if (res.code === '401') {
                        context.$message({
                            message: res.message,
                            type: 'error',
                            duration: 3000
                        })
                        return
                    } else {
                        this.$message({
                            message: '头像更新失败，请稍后再试',
                            type: 'error',
                            duration: 3000
                        })
                    }
                    this.updateAvatarFlag = false
                })
                .catch(err => {
                    console.warn(err)
                    this.$message({
                        message: '当前网络不可用，请检查网络设置',
                        type: 'error',
                        duration: 3000
                    })
                    this.updateAvatarFlag = false
                })
        },
        // base64转file
        dataURLtoFile(imgData, filename) {
            const arr = imgData.split(',')
            const mime = arr[0].match(/:(.*?);/)[1]
            const bstr = atob(arr[1])
            let n = bstr.length
            const u8arr = new Uint8Array(n)
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n)
            }
            // 以jpg的形式把file传给后台
            const updateFilename = filename.split('.')[0] + '1.jpg'
            return new File([u8arr], updateFilename, { type: mime })
        },
        // 展示所有部门
        showAllDeptInfo() {
            if (this.showAllDeptFlag) {
                this.deptInfoData = this.userData.deptInfo.slice(0)
            } else {
                this.deptInfoData.splice(1, this.deptInfoData.length)
            }
            this.showAllDeptFlag = !this.showAllDeptFlag
        },
        // 展示所有项目
        showAllProjectInfo() {
            if (this.showAllProjectFlag) {
                this.projectInfoData = this.userData.projectInfo.slice(0)
            } else {
                this.projectInfoData.splice(1, this.projectInfoData.length)
            }
            this.showAllProjectFlag = !this.showAllProjectFlag
        },
        showToolTip(e, flag) {
            if (this.optionsData.targets) return;
            const x = e.target.getBoundingClientRect().left - 40 + 15 // 减去toast的一半+按钮的一半
            const y = e.target.getBoundingClientRect().top - 40
            if (typeof flag === 'boolean') {
                this.starText = !flag ? '设为常用' : '移除常用'
            } else {
                this.starText = flag
            }
            this.starTop = y
            this.starLeft = x
            this.starDisplay = 'block'
        },
        hideToolTip() {
            this.starDisplay = 'none'
        },
        // 判断浏览器是否为ie
        isIe() {
            if (!!window.ActiveXObject || 'ActiveXObject' in window) {
                return true
            } else {
                return false
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.user-profile {
    width: 360px;
    height: 540px;
    z-index: 8001;
    text-align: initial;
    line-height: initial;
    white-space: initial;
    cursor: initial;
    &.default {
        width: 100%;
        height: 100%;
        position: fixed;
        left: 0;
        top: 0;
        overflow-y: auto;
    }
    .user-profile-main {
        width: 360px;
        //height: 540px;
        box-shadow: 0 8px 36px rgba(0, 0, 0, 0.18);
        background: #fff;
        box-sizing: border-box;
        border-radius: 6px;
        user-select: none;
        &.default {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translateX(-50%) translateY(-50%);
            -ms-transform: translateX(-50%) translateY(-50%); /* IE9及以上支持 */
        }
        .close-icon-box {
            width: 100%;
            height: 48px;
            padding: 12px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            flex-shrink: 0;
            &.close-opacity {
                //background: rgba(255, 255, 255, 0.72);
                //backdrop-filter: blur(60px);
                background: rgba(255, 255, 255, 0.96);
                backdrop-filter: blur(60px);
            }
            .close-icon {
                width: 24px;
                height: 24px;
                z-index: 12;
                cursor: pointer;
            }
        }
        .user-profile-box {
            //height: 540px;
            .user-profile-show-box {
                position: relative;
                display: flex;
                flex-direction: column;
                border-radius: 6px;
                overflow: hidden;
            }
            .avatar-box {
                position: absolute;
                right: 18px;
                top: 108px;
                width: 0;
                height: 0;
                background-color: #fff;
                box-sizing: border-box;
                box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
                border-radius: 4px;
                //display: flex;
                //justify-content: center;
                //align-items: center;
                z-index: 50;
                cursor: default;
                overflow: hidden;
                opacity: 0;
                &.showAvatarBox {
                    animation-name: showAvatar;
                    animation-duration: 0.4s;
                    width: 324px;
                    height: 324px;
                    padding: 12px;
                    opacity: 1;
                    animation-timing-function: ease-out;
                }
                &.isLoginUser {
                    height: 378px;
                }
                @keyframes showAvatar {
                    0% {
                        width: 0;
                        height: 0;
                        opacity: 0;
                    }
                    50% {
                        width: 330px;
                        height: 330px;
                        opacity: 0.7;
                    }
                    100% {
                        width: 324px;
                        min-height: 324px;
                        max-height: 378px;
                        opacity: 1;
                    }
                }
                .avatar-main {
                    width: 302px;
                    height: 302px;
                    border: 1px solid #eaeaea;
                    box-sizing: border-box;
                    border-radius: 2px;
                    overflow: hidden;
                    line-height: 300px;
                    text-align: center;
                    color: #fff;
                    font-size: 100px;
                    &.avatarBg-0 {
                        background-color: #75b6f0;
                    }
                    &.avatarBg-1 {
                        background-color: #eeae5b;
                    }
                    &.avatarBg-2 {
                        background-color: #60bbf2;
                    }
                    &.avatarBg-3 {
                        background-color: #f27c60;
                    }
                    &.avatarBg-4 {
                        background-color: #f16e6e;
                    }
                    &.avatarBg-5 {
                        background-color: #609af2;
                    }
                }
                .btn-box {
                    width: 300px;
                    height: 36px;
                    margin-top: 18px;
                    .uploadConfirm {
                        display: block;
                        width: 300px;
                        height: 36px;
                        box-sizing: border-box;
                        background: #007af5;
                        //border: 1px solid #5587f0;
                        border-radius: 2px;
                        font-style: normal;
                        font-weight: normal;
                        font-size: 14px;
                        line-height: 36px;
                        text-align: center;
                        color: #fff;
                        cursor: pointer;
                        &:hover {
                            background: #006edd;
                        }
                    }
                }
            }
            .avatar-update-box {
                position: absolute;
                right: 18px;
                top: 108px;
                width: 0;
                height: 0;
                background-color: #fff;
                box-sizing: border-box;
                box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
                border-radius: 4px;
                //display: flex;
                //justify-content: center;
                //align-items: center;
                z-index: 50;
                cursor: default;
                overflow: hidden;
                opacity: 0;
                &.updateBoxIsShow {
                    animation-name: showUpdateAvatar;
                    animation-duration: 0.5s;
                    width: 324px;
                    height: 426px;
                    padding: 12px;
                    opacity: 1;
                    animation-timing-function: ease-out;
                }
                @keyframes showUpdateAvatar {
                    0% {
                        width: 0;
                        height: 0;
                        opacity: 0;
                    }
                    50% {
                        width: 330px;
                        height: 430px;
                        opacity: 0.7;
                    }
                    100% {
                        width: 324px;
                        height: 426px;
                        opacity: 1;
                    }
                }
                .update-avatar-main {
                    width: 302px;
                    height: 302px;
                    border: 1px solid #eaeaea;
                    border-radius: 4px;
                    overflow: hidden;
                    box-sizing: border-box;
                    //display: flex;
                    //flex-direction: column;
                    //align-items: center;
                    //justify-content: center;
                    position: relative;
                    img {
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        transform: translate(-50%, -50%);
                    }
                }
                .update-avatar-operate {
                    width: 100%;
                    height: 42px;
                    margin: 12px 0;
                    .update-avatar-operate-main {
                        width: 133px;
                        height: 42px;
                        margin: 0 auto;
                        box-sizing: border-box;
                        padding: 11px 0;
                        border: 1px solid #eaeaea;
                        border-radius: 26px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        .update-avatar-operate-enlarge,
                        .update-avatar-operate-narrow {
                            width: 24px;
                            height: 24px;
                            box-sizing: border-box;
                            font-size: 24px;
                            line-height: 24px;
                            cursor: pointer;
                            color: #6f6f6f;
                            img {
                                width: 24px;
                                height: 24px;
                            }
                            .avatar-enlarge-hover,
                            .avatar-narrow-hover {
                                display: none;
                            }
                        }
                        .update-avatar-operate-enlarge {
                            &:hover {
                                .avatar-enlarge-hover-img {
                                    display: none;
                                }
                                .avatar-enlarge-hover {
                                    display: inline;
                                }
                            }
                        }
                        .update-avatar-operate-narrow {
                            &:hover {
                                .avatar-narrow-hover-img {
                                    display: none;
                                }
                                .avatar-narrow-hover {
                                    display: inline;
                                }
                            }
                        }
                        .update-avatar-operate-line {
                            width: 1px;
                            height: 18px;
                            margin: 3px 22px;
                            background: #f5f5f5;
                        }
                    }
                }
                .update-avatar-button {
                    width: 100%;
                    height: 36px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    .update-avatar-button-cancel {
                        width: 144px;
                        height: 36px;
                        background: #f4f5f6;
                        border: 0;
                        box-sizing: border-box;
                        border-radius: 2px;
                        align-items: center;
                        line-height: 36px;
                        font-size: 14px;
                        color: #323232;
                        cursor: pointer;
                        &:hover {
                            background: #eef0f2;
                        }
                        &[disabled] {
                            background: #fff;
                            border: 1px solid #eaeaea;
                            color: #c1c1c1;
                            cursor: not-allowed;
                        }
                    }
                    .update-avatar-button-submit {
                        width: 144px;
                        height: 36px;
                        background: #007af5;
                        border: 0;
                        box-sizing: border-box;
                        border-radius: 2px;
                        align-items: center;
                        line-height: 36px;
                        font-size: 14px;
                        color: #fff;
                        cursor: pointer;
                        &:hover {
                            background: #006edd;
                        }
                        &[disabled] {
                            background: #0062c4;
                            cursor: not-allowed;
                        }
                    }
                }
            }
        }
        .user-profile-content {
            flex-grow: 1;
            overflow-y: auto;
            position: relative;
            display: flex;
            flex-direction: column;
            scrollbar-width: none; // firefox下滚动条不显示
            -ms-overflow-style: none; // IE下滚动条不显示
            //设置侧边栏滚动条不显示 chrome
            &::-webkit-scrollbar {
                display: none;
            }
            & > :nth-child(2) {
                border-radius: 12px 12px 0 0;
            }
            .user-message {
                padding: 0 18px 12px;
                position: relative;
                //min-height: 240px;
                box-sizing: border-box;
                display: flex;
                flex-direction: column;
                z-index: 10;
                flex-shrink: 0;
                .basic-message {
                    display: flex;
                    justify-content: space-between;
                    position: relative;
                    .message-left {
                        flex: 1;
                        .user-details {
                            margin-bottom: 2px;
                            display: flex;
                            align-items: center;
                            label {
                                color: #fff;
                                opacity: 0.6;
                                font-size: 14px;
                                margin-right: 12px;
                            }
                            span {
                                font-size: 14px;
                                line-height: 22px;
                                color: #ffffff;
                                user-select: text;
                            }
                            a {
                                font-size: 12px;
                                color: #323232;
                            }
                        }
                        .user-name {
                            .isstar {
                                width: 18px;
                                height: 18px;
                                margin-right: 6px;
                            }
                            .name {
                                max-width: 230px;
                                font-size: 16px;
                                font-weight: 600;
                                color: #fff;
                                margin: 0 6px 0 0;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                overflow: hidden;
                                height: 24px;
                                user-select: text;
                                line-height: 24px;
                                .dot {
                                    padding: 0 4px;
                                    //transform: scale(20);
                                }
                            }
                            .aiAgentName{
                                max-width: 190px;
                            }
                            .user-star {
                                width: 18px;
                                height: 18px;
                            }
                            .aiAgent-star{
                                height: 18px;
                                width: auto;
                            }
                        }
                        .lxaccount {
                            span {
                                max-width: 212px;
                            }
                        }
                        .user-commonweal-cdn {
                            position: relative;
                            margin-left:6px;
                            .user-commonweal-cdn-avatar{
                                display: flex;
                                img{
                                    width: 76px;
                                height: 20px;
                                }

                            }
                            .user-commonweal-cdn-popover-box{
                                position: absolute;
                                padding-top: 6px;

                                z-index:1;

                            }
                            .user-commonweal-cdn-popover{
                                border-radius: 4px;
                                border: 1px solid #EBEEF5;
                                box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
                                width: 92px;
                                padding: 12px;
                                background: white;
                                box-sizing: content-box;

                                .user-commonweal-cdn-item {
                                    display: flex;
                                    flex-direction: column;
                                    span {
                                        color: #000;
                                        font-size: 14px;
                                        line-height: 22px;
                                    }
                                    img {
                                        width: 92px;
                                        height: 24px;
                                        margin-top: 6px;
                                    }
                                }
                                .user-commonweal-cdn-item-box+ .user-commonweal-cdn-item-box{
                                    margin-top:12px;
                                }
                            }

                        }

                        .phone {
                            .user-phone {
                                width: 102px;
                            }
                            .eye {
                                width: 18px;
                                height: 18px;
                                margin-left: 12px;
                                cursor: pointer;
                                &:hover {
                                    opacity: 0.8;
                                }
                            }
                        }
                    }
                    .message-right {
                        width: 56px;
                        height: 56px;
                        position: relative;
                        .user-profile-avatar {
                            width: 56px;
                            height: 56px;
                            margin: 0;
                            border: 2px solid rgba(255, 255, 255, 0.6);
                            box-sizing: border-box;
                            border-radius: 50%;
                        }
                    }
                }
                .signature {
                    width: 100%;
                    margin-top: 12px;
                    .signature-label {
                        color: #999;
                        font-size: 12px;
                        margin-bottom: 6px;
                    }
                    .signature-text {
                        color: #999;
                        font-size: 12px;
                        position: relative;
                        span {
                            font-size: 14px;
                            line-height: 22px;
                            color: #ffffff;
                            user-select: text;
                            word-break: break-all;
                            word-wrap: break-word;
                        }
                        .signature-text-show {
                            opacity: 0.7;
                        }
                        .edit-signature {
                            width: 18px;
                            height: 18px;
                            cursor: pointer;
                            color: #fff;
                            vertical-align: text-top;
                            &:hover {
                                opacity: 0.8;
                            }
                        }
                        .signature_close {
                            cursor: pointer;
                            width: 12px;
                            height: 12px;
                            padding: 3px;
                            position: absolute;
                            top: 5px;
                            right: 4px;
                            color: #fff;
                        }
                        .signature-area {
                            border-radius: 4px;
                            border: 1px solid #fff;
                            font-size: 14px;
                            line-height: 22px;
                            box-sizing: border-box;
                            width: 100%;
                            height: 90px;
                            background: transparent;
                            padding: 10px 12px;
                            color: #fff;
                            word-break: break-all;
                            word-wrap: break-word;
                            font-family: 'PingFang SC', 'Helvetica Neue',
                                'Hiragino Sans GB', 'Segoe UI',
                                'Microsoft YaHei', '微软雅黑', sans-serif; // 处理ie兼容问题
                            &::-webkit-input-placeholder {
                                color: #d6d6d6;
                            }
                            &.signature-area-full {
                                border: 1px solid #ff3b30;
                            }
                        }
                        .word-number {
                            position: absolute;
                            bottom: 10px;
                            right: 10px;
                            color: #c1c1c1;
                            font-size: 14px;
                            &.signature-area-full {
                                color: #ff3b30;
                            }
                        }
                    }
                }
                .btn {
                    height: 30px;
                    margin-top: 12px;
                    display: flex;
                    align-items: center;
                    .btn-box {
                        width: 30px;
                        height: 30px;
                        margin-right: 24px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        background: rgba(255, 255, 255, 0.2);
                        border-radius: 50%;
                        cursor: pointer;
                        &:hover {
                            opacity: 0.8;
                        }
                        img {
                            width: 18px;
                            height: 18px;
                        }
                    }
                }
            }
            .user-profile-line {
                width: 100%;
                height: 6px;
                background: rgba(255, 255, 255, 0.96);
                flex-shrink: 0;
                .line {
                    width: 100%;
                    height: 6px;
                    background: rgba(0, 0, 0, 0.04);
                }
            }
            .company {
                width: 100%;
                min-height: 58px;
                padding: 6px 12px;
                box-sizing: border-box;
                background-color: rgba(255, 255, 255);
                backdrop-filter: blur(60px);
                border-bottom: 1px solid rgba(0, 0, 0, 0.04);
                flex-shrink: 0;
                user-select: text;
                .company-label {
                    color: #323232;
                    margin-bottom: 2px;
                    font-size: 14px;
                    line-height: 22px;
                }
                .company-text {
                    color: #6f6f6f;
                    font-size: 14px;
                    line-height: 22px;
                }
            }
            .department-position {
                user-select: text;
                background-color: rgba(255, 255, 255);
                flex-grow: 1;
                flex-shrink: 0;
                .message-btn {
                    user-select: none;
                    height: 42px;
                    padding: 0 12px;
                    display: flex;
                    box-sizing: border-box;
                    border-bottom: 1px solid rgba(0, 0, 0, 0.04);
                    span {
                        height: 42px;
                        line-height: 42px;
                        box-sizing: border-box;
                        font-size: 14px;
                        color: #6f6f6f;
                        margin-right: 36px;
                        cursor: pointer;
                    }
                    .active {
                        color: #007af5;
                        cursor: default;
                        border-bottom: 2px solid #007af5;
                        font-weight: 600;
                    }
                }
                .department-message,
                .project-message {
                    width: 100%;
                    min-height: 40px;
                    //max-height: 254px;
                    font-size: 12px;
                    padding: 12px 0;
                    box-sizing: border-box;
                    .department-list {
                        padding: 0 12px 12px;
                        border-bottom: 1px rgba(0, 0, 0, 0.04) solid;
                        margin-bottom: 12px;
                        &:last-child {
                            border: none;
                            padding-bottom: initial;
                        }
                        .department-list-one {
                            display: flex;
                            .left {
                                width: 58px;
                                margin-right: 12px;
                                font-size: 14px;
                                line-height: 22px;
                                text-align: right;
                                color: #999999;
                                &.short {
                                    width: 28px;
                                }
                                &.AiWidth{
                                    width: 43px;
                                    text-align: left;
                                }
                            }
                            .right {
                                flex: 1;
                                line-height: 22px;
                                .dept-breadcrumb {
                                    .deptItem {
                                        font-size: 14px;
                                        line-height: 22px;
                                        //color: #5587F0;
                                        color: #323232;
                                        //cursor: pointer;
                                    }
                                    .dept-separatorline {
                                        font-size: 14px;
                                        line-height: 22px;
                                        padding: 0 2px;
                                        color: #333;
                                    }
                                }
                                .position {
                                    font-size: 14px;
                                    line-height: 22px;
                                    color: #323232;
                                }
                            }
                            &.last-item {
                                margin-top: 6px;
                            }
                        }
                    }
                    .department-show-all {
                        width: 100%;
                        height: 42px;
                        border-top: 1px solid rgba(0, 0, 0, 0.04);
                        user-select: none;
                        .department-show-all-box {
                            width: 80px;
                            height: 100%;
                            margin: 0 auto;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            line-height: 42px;
                            font-size: 14px;
                            color: #323232;
                            cursor: pointer;
                            &:hover {
                                color: #006edd;
                                .org-show-all {
                                    display: none;
                                }
                                .org-show-all-hover {
                                    display: inline;
                                }
                            }
                            .org-show-all {
                                width: 18px;
                                height: 18px;
                                &.rotate {
                                    transform: rotate(180deg);
                                }
                            }
                            .org-show-all-hover {
                                width: 18px;
                                height: 18px;
                                display: none;
                                &.rotate {
                                    transform: rotate(180deg);
                                }
                            }
                        }
                    }
                }
            }
            .no-organization {
                width: 100%;
                background: rgba(255, 255, 255, 0.96);
                backdrop-filter: blur(60px);
                font-size: 12px;
                color: #999;
                display: flex;
                justify-content: center;
                align-items: center;
                flex: 1;
            }
            .user-quit {
                //padding: 30px 0;
                flex: 1;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                background-color: rgba(255, 255, 255, 0.96);
                .quit-img {
                    font-size: 90px;
                }
                .quit-text {
                    height: 22px;
                    color: #464646;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 14px;
                    margin-top: 12px;
                }
                .quit-function {
                    width: 180px;
                    height: 36px;
                    border-radius: 2px;
                    line-height: 36px;
                    font-size: 14px;
                    color: #fff;
                    text-align: center;
                    cursor: pointer;
                    background: #007af5;
                    display: block;
                    margin-top: 18px;
                    &:hover {
                        background: #006edd;
                    }
                }
            }
        }
        .user-function-box {
            width: 100%;
            height: 60px;
            background: rgba(255, 255, 255, 0.96);
            backdrop-filter: blur(60px);
            flex-shrink: 0;
        }
        .user-function {
            width: 100%;
            height: 60px;
            box-sizing: border-box;
            background: rgba(255, 255, 255, 0.86);
            backdrop-filter: blur(60px);
            display: flex;
            justify-content: center;
            //padding: 0 40px;
            border-top: 1px solid rgba(0, 0, 0, 0.04);
            align-items: center;
            .function-btn {
                height: 42px;
                width: 48px; // 谷歌浏览器不支持10px，最小12px，所以设置更宽一些
                border: none;
                text-align: center;
                cursor: pointer;
                display: flex;
                flex-direction: column;
                justify-content: center;
                margin: 0 36px;
                align-items: center;
                .btn-icon {
                    width: 24px;
                    height: 24px;
                }
                .btn-icon-hover {
                    display: none;
                    width: 24px;
                    height: 24px;
                }
                span {
                    font-size: 10px;
                    line-height: 18px;
                    color: #323232;
                }
                &:hover {
                    .btn-icon {
                        display: none;
                    }
                    .btn-icon-hover {
                        display: inline;
                    }
                    span {
                        color: #006edd;
                    }
                }
            }
        }
        .tips {
            position: absolute;
            top: 18px;
            left: 50%;
            transform: translateX(-50%);
            display: flex;
            align-items: center;
            justify-content: center;
            height: 42px;
            padding: 0 12px;
            background: #ffffff;
            border: 1px solid #f5f5f5;
            box-sizing: border-box;
            box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
            border-radius: 6px;
            z-index: 99;
            .tips-img {
                width: 24px;
                height: 24px;
                margin-right: 6px;
                flex-shrink: 0;
            }
            span {
                font-weight: 600;
                font-size: 14px;
                color: #323232;
                word-break: keep-all;
            }
        }
        .noAuthority,
        .loading,
        .data-loading-failed {
            height: 492px;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            background: rgba(255, 255, 255, 0.96);
            backdrop-filter: blur(60px);
            padding-bottom: 48px;
            box-sizing: border-box;
            .noAuthority-img,
            .loading-img,
            .data-loading-failed-img {
                width: 90px;
                height: 90px;
            }
            .noAuthority-text,
            .loading-text,
            .data-loading-failed-text {
                margin-top: 12px;
                font-size: 14px;
                line-height: 22px;
                color: #464646;
            }
            .data-loading-failed-btn {
                width: 180px;
                height: 36px;
                margin-top: 18px;
                .reload {
                    width: 100%;
                    height: 36px;
                    font-size: 14px;
                    color: #fff;
                    text-align: center;
                    line-height: 36px;
                    border: 0;
                    background: #007af5;
                    border-radius: 2px;
                    cursor: pointer;
                    &:hover {
                        background-color: #006edd;
                    }
                }
            }
        }
    }
    .star-text-set {
        height: 22px;
        position: fixed;
        color: #fff;
        text-align: center;
        line-height: 22px;
        padding: 6px 12px;
        background: rgba(0, 0, 0, 0.9);
        border-radius: 4px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
        font-size: 14px;
        display: none;
    }
}
</style>
